const APP_NAME = "PwaTimer"
const ROUTE_PREFIX = "/pwa-timer"


export {APP_NAME, ROUTE_PREFIX};